export const capitalize = (word: string) =>
  word.charAt(0).toUpperCase() + word.slice(1);

export const numberToCurrency = (number: number) =>
  // no decimal places
  new Intl.NumberFormat("cs-CZ", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
  }).format(number);
